import Vue from "vue"
import Vuex from "vuex"
import config from "@/config/index.js"
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem(config.tokenKey) || "",
    userInfo: localStorage.getItem(config.userInfoKey) ? JSON.parse(localStorage.getItem(config.userInfoKey)) : {},
    currentChatMessage: {},
    reChatMessage: {},
    customerListShow: false,
    chatShow: false,
    autoText: ""
  },
  getters: {
    token: (state) => state.token,
    userInfo: (state) => state.userInfo,
    globalConfig: (state) => state.globalConfig,
    customerListShow: (state) => state.customerListShow,
    chatShow: (state) => state.chatShow,
    autoText: (state) => state.autoText,
  },
  mutations: {
    SET_TOKEN(state, data) {
      localStorage.setItem(config.tokenKey, data);
      state.token = data;
    },
    SET_USERINFO(state, data) {
      localStorage.setItem(config.userInfoKey, JSON.stringify(data));
      state.userInfo = data;
    },
    removeUserInfo(state) {
      state.userInfo = {};
      state.token = "";
      localStorage.removeItem(config.tokenKey);
      localStorage.removeItem(config.userInfoKey);
    },
    SET_CURRENT_CHAT_MESSAGE(state, data) {
      state.currentChatMessage = data;
    },
    SET_RE_CHAT_MESSAGE(state, data) {
      state.reChatMessage = data;
    },
    SET_GLOBAL_CONFIG(state, data) {
      state.globalConfig = data;
    },
    SET_CUSTOMERLIST_SHOW(state, data) {
      state.customerListShow = data;
    },
    SET_CHAT_SHOW(state, data) {
      state.chatShow = data;
    },
    SET_AUTO_TEXT(state, data) {
      state.autoText = data;
    }
  },
  actions: {
    setToken({ commit }, data) {
      commit("SET_TOKEN", data);
    },
    
    async setUserInfo({ commit }) {
      let uuid = localStorage.getItem('uuid');
      if (!uuid) {
        uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
        localStorage.setItem('uuid', uuid);
      }
      let str = uuid.substring(0, 6)
      let userInfo = {
        userId: uuid,
        account: uuid,
        nickname: uuid
      }
      commit("SET_USERINFO", userInfo)
    },
    setGlobalConfig({ commit }, data) {
      commit("SET_GLOBAL_CONFIG", data);
    },
    setCustomerListShow({ commit }, data) {
      commit("SET_CUSTOMERLIST_SHOW", data);
    },
    setChatShow({ commit }, data) {
      commit("SET_CHAT_SHOW", data);
    },
    setAutoText({ commit }, data) {
      commit("SET_AUTO_TEXT", data);
    },
  },
  modules: {},
});
